var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M494.139,476.278H52.515l66.881-92.696c30.558,9.792,62.732-7.276,72.492-37.09h49.103 c7.534,23.015,29.199,39.689,54.699,39.689c39.873,0,67.873-39.886,54.006-77.432l72.9-57.552 c10.329,6.892,22.997,10.541,36.544,9.46c28.036-2.237,50.601-24.921,52.694-52.969c2.516-33.709-24.2-61.943-57.387-61.943 c-39.873,0-67.873,39.886-54.006,77.432l-72.9,57.552c-31.558-21.054-74.699-6.161-86.55,30.041H191.63 c-9.253-28.266-39.825-46.971-72.635-36.96c-17.752,5.416-31.714,19.543-37.015,37.329c-5.724,19.208-1.599,37.6,8.475,51.38 l-54.734,75.862V18.33c0-9.168-6.717-17.211-15.829-18.218C9.119-1.076,0.001,7.328,0.001,17.861v476.278 c0,9.647,7.863,17.862,17.845,17.862c0.007,0,0.013-0.001,0.02-0.001H493.67c9.168,0,17.211-6.717,18.218-15.829 C513.076,485.397,504.673,476.278,494.139,476.278z M454.45,181.947c12.037,0,21.829,9.792,21.829,21.829 s-9.793,21.829-21.829,21.829c-12.036,0-21.829-9.793-21.829-21.829C432.621,191.74,442.413,181.947,454.45,181.947z  M295.691,307.283c12.037,0,21.829,9.792,21.829,21.829s-9.792,21.829-21.829,21.829s-21.83-9.791-21.83-21.829 C273.861,317.075,283.654,307.283,295.691,307.283z M136.931,307.283c12.037,0,21.829,9.792,21.829,21.829 s-9.792,21.829-21.829,21.829s-21.829-9.792-21.829-21.829S124.894,307.283,136.931,307.283z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGraph);
export default __webpack_public_path__ + "static/media/line-graph.9780f559.svg";
export { ForwardRef as ReactComponent };